export class StandardException {
    constructor(message, log = false) {
        this.message = message;
        if (log) {
            console.error('StandardException raised: ', message);
        }
    }
}
